import { getTradingBattleContract } from 'utils/contractHelpers'

const tradingBattleContract = getTradingBattleContract()

export const fetchClaimInformation = async (account: string) => {
  const claimInformation = await tradingBattleContract.claimInformation(account)
  return claimInformation
}
